import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getDrivers,
  getDriverById,
  createDriver,
  updateDriver,
  deleteDriver,
} from "./drivers.service";

export const useGetDrivers = (params = {}) => {
  return useQuery({
    queryKey: ["drivers", params],
    queryFn: () => getDrivers(params),
  });
};

export const useGetDriverById = (driverId) => {
  return useQuery({
    queryKey: ["drivers", driverId],
    queryFn: () => getDriverById(driverId),
    enabled: Boolean(driverId),
  });
};

export const useCreateDriverMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createDriver,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["drivers"] });
    },
  });
};

export const useUpdateDriverMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ driverId, driverData }) => updateDriver(driverId, driverData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["drivers"] });
    },
  });
};

export const useDeleteDriverMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteDriver,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["drivers"] });
    },
  });
};
